import React from "react";

import Card from "@mui/joy/Card";
import CardContent from "@mui/joy/CardContent";
import {CardOverflow, Stack} from "@mui/joy";
import Typography from "@mui/joy/Typography";
import Chip from "@mui/joy/Chip";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import IconButton from "@mui/joy/IconButton";
import Link from "@mui/joy/Link";

import UserSubscriberContext from "../../context/UserSubscriberContext";

// icons
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import AccountCard from "../Cards/AccountCard";


class OpportunityMiniCard extends React.Component {
    static contextType = UserSubscriberContext

     constructor(props) {
        super(props);
        this.state = {
            mlModal: false,
            mlProcess: false,
            mlResponse: null,
        }
    }

    setOpportunity(){
        this.props.callBack(
            this.props.opportunity,
            this.props.delivery_states,
            this.props.color,
        )
    }

    render() {
        let hasDeliveryStates = (()=>{
            for (const state of this.props.delivery_states){
                if (state.operator.id === this.context.subscriberObject.id){
                    return true
                }
            }
            return false
        })()
        return(
            <Card
                orientation={'horizontal'}
                size={'sm'}
                color={this.props.selected?'primary':'neutral'}
                variant={this.props.selected?'soft':'outlined'}
                sx={{
                    width: this.props.width?this.props.width:null
                }}
            >
                <CardContent
                    sx={{
                        justifyContent: 'space-between',
                    }}
                >
                    <Stack
                        direction={'row'}
                        sx={{
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                    >
                        <Stack
                            spacing={1}
                            sx={{
                                maxWidth: '80%',
                            }}
                        >
                            <Stack
                                direction={'row'}
                                spacing={1}
                            >
                                <Typography
                                    level={'title-sm'}
                                >
                                    <Link
                                        href={`/opportunity/detail/${this.props.opportunity.id}`}
                                        target={'_blank'}
                                    >
                                        {this.props.opportunity.short_name}
                                    </Link>
                                </Typography>
                            </Stack>
                            <AccountCard
                                account={this.props.opportunity.account}
                                mini={true}
                            />
                            <Stack
                                direction={'row'}
                                spacing={1}
                                useFlexGap
                                sx={{ flexWrap: 'wrap' }}
                            >
                                {this.props.my_roles.map(
                                    row => {
                                        return (
                                            <Chip
                                                color={row.color}
                                                key={'my-role-chip-' + row.id}
                                            >
                                                {row.role_human.slice(0, 3)}
                                            </Chip>
                                        )
                                    })
                                }
                            </Stack>
                        </Stack>
                        <Stack
                            direction={'row'}
                            spacing={1}
                            useFlexGap
                            sx={{
                                flexWrap: 'wrap',
                                alignItems: 'center',
                            }}
                        >
                            {
                                hasDeliveryStates && this.props.showDeliveryStates?
                                    <IconButton
                                        color={'warning'}
                                        size={'sm'}
                                        sx={{
                                            cursor: 'auto'
                                        }}
                                    >
                                        <AccountTreeIcon/>
                                    </IconButton>:null
                            }
                            {
                                this.props.extraModules?
                                    <>
                                        {this.props.extraModules.map((e) => (<>{e}</>))}
                                    </>
                                    :
                                    null
                            }

                        </Stack>
                    </Stack>
                </CardContent>
                {
                    this.props.callBack?
                        <CardOverflow
                            color={this.props.selected?'primary':'neutral'}
                            variant={this.props.selected?'solid':'soft'}
                            sx={{
                                justifyContent: "center",
                                alignItems: "center",
                                "&:hover": {
                                    cursor: 'pointer',
                                },
                                pl: 0.5,
                                pr: 0.5
                            }}
                            onClick={this.setOpportunity.bind(this)}
                        >
                            <ChevronRightIcon
                                sx={{
                                    fontSize: '18px',
                                }}
                            />
                        </CardOverflow>:
                        null
                }

            </Card>
        )
    }
}

export default OpportunityMiniCard
